
import {Component, Prop, Vue} from "vue-property-decorator";
import OkDialog from "@/components/common/OkDialog.vue";
import {translate} from "@/auxillary/translation";
import {stringify} from "@/auxillary/datafield.stringify";
import ReadonlyDataField from "@/models/ReadonlyDataField";

@Component({
  name: 'IntegerFieldReadonly',
  components: {
    OkDialog,
  },
})
export default class IntegerFieldReadonly extends Vue {

  @Prop({required: true})
  private dataField: ReadonlyDataField

  errorMessage: string = "";


  get labelField() {
    return this.labelLength <= 15 ? this.displayName : ""
  }

  get labelAbove() {
    return this.labelLength > 15 ? this.displayName : ""
  }

  get labelLength() {
    return this.suffix.length + this.displayName.length
  }

  get displayName() {
    if (!this.dataField.displayName) return ""
    return this.dataField.displayName;
  }

  get isVisible() {
    return this.field.isVisible;
  }

  get isReadonly() {
    return true;
  }

  get value() {
    this.validateInput()
    const value = this.dataField.values.value;
    return (value === "unknown") ? "" : value
  }

  get canBeUnknown() {
    return this.field.definition.canBeUnknown ?? false;
  }

  get unknown() {
    return this.dataField.values.unknown
  }

  stringifyValue() {
    return stringify(this.field)
  }

  get field() {
    return this.dataField;
  }

  get width() {
    // TODO needs better dynnamic width
    return 100 + (Math.max(this.suffix.length - 5, 0) * 5);
  }

  get suffix() {
    return translate(this.field.definition.unit, "unit") ?? "";
  }

  get minValue() {
    return this.field.definition.min;
  }

  get maxValue() {
    return this.field.definition.max;
  }

  validateKeyPress(evt: KeyboardEvent) {
    const keysAllowed: string[] = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
    const keyPressed: string = evt.key;
    if (!keysAllowed.includes(keyPressed)) {
      evt.preventDefault()
    }
  }

  validateInput() {
    const value = this.dataField.values?.value;
    if (value) {
      const intValue = Number.parseInt(value);
      if (this.minValue) {
        if (intValue < this.minValue) {
          this.errorMessage = "Minimalwert: " + this.minValue;
          return;
        }
      }
      if (this.maxValue) {
        if (intValue > this.maxValue) {
          this.errorMessage = "Maximalwert: " + this.maxValue;
          return;
        }
      }
    }
    this.errorMessage = "";
  }
}
